import { Heading } from '@chakra-ui/react';
import React from 'react';

import styles from './page-title.module.scss';

interface PageTitleProps {
  children: React.ReactNode;
  as?: any;
}

export function PageTitle({ children, as = 'h1' }: PageTitleProps) {
  return (
    <Heading as={as} className={styles.pageTitle} fontFamily="KiaSignature">
      {children}
    </Heading>
  );
}
